import { getResponseErrorCode } from '../../../../utils/get-response-error-code';
export var CreateFriendCodeErrorCodeV1;
(function(CreateFriendCodeErrorCodeV1) {
    CreateFriendCodeErrorCodeV1[CreateFriendCodeErrorCodeV1[/**
     * Member does not have an active subscription.
     */ "MemberDoesNotHaveAnActiveSubscription"] = 34000] = "MemberDoesNotHaveAnActiveSubscription";
    CreateFriendCodeErrorCodeV1[CreateFriendCodeErrorCodeV1[/**
     * Member's friend limit reached.
     */ "MembersFriendLimitReached"] = 34003] = "MembersFriendLimitReached";
})(CreateFriendCodeErrorCodeV1 || (CreateFriendCodeErrorCodeV1 = {}));
export class CreateFriendCodeErrorV1 extends Error {
    constructor(errorCode){
        const error = `Failed to create friend code. API error code ${errorCode}: ${CreateFriendCodeErrorCodeV1[errorCode]}`;
        super(error);
        this.errorCode = errorCode;
    }
}
export async function getCreateFriendCodeErrorV1(error) {
    const errorCode = await getResponseErrorCode(error);
    return errorCode && Object.values(CreateFriendCodeErrorCodeV1).includes(errorCode) ? new CreateFriendCodeErrorV1(errorCode) : error;
}

//# sourceMappingURL=create-friend-code-error.js.map